<template>
    <div class="rounded-[12.8px] border border-[#E5E7EB] bg-white p-4 p-[21px]">
        <slot></slot>
    </div>
</template>

<script setup lang="ts"></script>
